import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function getAnimalLotHistory(payload) {
  const { groupId, farmId, animalId, signal } = payload;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/${animalId}/lots/histories`,
    getHeaders(false, signal)
  );
}

export function getAnimalPicketHistory(payload) {
  const { groupId, farmId, animalId, signal } = payload;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/${animalId}/pickets/histories`,
    getHeaders(false, signal)
  );
}
